import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';
import { TURNSTILE_SITE_KEY } from '../config/constants';

interface TurnstileWidgetProps {
  onVerify: (token: string) => void;
  onError?: (error: any) => void;
}

const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({ onVerify, onError }) => {
  if (!TURNSTILE_SITE_KEY) {
    console.warn('Turnstile Site Key is missing. Please set REACT_APP_TURNSTILE_SITE_KEY in your environment variables.');
    return (
      <div style={{padding: '10px', border: '1px solid red', borderRadius: '4px', color: 'red', background: '#fff0f0'}}>
        <strong>Configuration Error:</strong> Turnstile Site Key is missing.
      </div>
    );
  }

  return (
    <div className="turnstile-container" style={{margin: '20px 0'}}>
      <Turnstile siteKey={TURNSTILE_SITE_KEY} onSuccess={onVerify} onError={onError} />
    </div>
  );
};

export default TurnstileWidget;
